import { render, staticRenderFns } from "./CountedServiceTable.vue?vue&type=template&id=aebb779e&"
import script from "./CountedServiceTable.vue?vue&type=script&lang=js&"
export * from "./CountedServiceTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports